export default __webpack_public_path__ + "static/media/blog.833bafd8.png";